import buy from "../../../src/assets/sounds/lesson5/buy.mp3"
import cold_tea from "../../../src/assets/sounds/lesson5/cold_tea.mp3"
import cup from "../../../src/assets/sounds/lesson5/cup.mp3"
import currency from "../../../src/assets/sounds/lesson5/currency.mp3"
import eat from "../../../src/assets/sounds/lesson5/eat.mp3"
import how_much from "../../../src/assets/sounds/lesson5/how_much.mp3"
import kilogram from "../../../src/assets/sounds/lesson5/kilogram.mp3"
import mango from "../../../src/assets/sounds/lesson5/mango.mp3"
import money from "../../../src/assets/sounds/lesson5/money.mp3"
import please from "../../../src/assets/sounds/lesson5/please.mp3"
import price from "../../../src/assets/sounds/lesson5/price.mp3"
import rice_noodle from "../../../src/assets/sounds/lesson5/rice_noodle.mp3"
import sell from "../../../src/assets/sounds/lesson5/sell.mp3"
import unit from "../../../src/assets/sounds/lesson5/unit.mp3"
import wait from "../../../src/assets/sounds/lesson5/wait.mp3"
import want from "../../../src/assets/sounds/lesson5/want.mp3"
import welcome from "../../../src/assets/sounds/lesson5/welcome.mp3"
import buy_pic from "../../../src/assets/lesson5/buy.png"
import cold_tea_pic from "../../../src/assets/lesson5/cold_tea.png"
import cup_pic from "../../../src/assets/lesson5/cup.png"
import currency_pic from "../../../src/assets/lesson5/money.png"
import eat_pic from "../../../src/assets/lesson5/eat.png"
import how_much_pic from "../../../src/assets/lesson5/how_much.png"
import kilogram_pic from "../../../src/assets/lesson5/kilogram.png"
import mango_pic from "../../../src/assets/lesson5/mango.png"
import money_pic from "../../../src/assets/lesson5/money.png"
import please_pic from "../../../src/assets/lesson5/please.png"
import price_pic from "../../../src/assets/lesson5/price.png"
import rice_noodle_pic from "../../../src/assets/lesson5/rice_noodle.png"
import sell_pic from "../../../src/assets/lesson5/sell.png"
import unit_pic from "../../../src/assets/lesson5/unit.png"
import wait_pic from "../../../src/assets/lesson5/wait.png"
import want_pic from "../../../src/assets/lesson5/want.png"
import welcome_pic from "../../../src/assets/lesson5/welcome.png"

export const unit_5=[
    {id: 0, english: "How much", vietnamese: "Bao nhiêu tiền", example:"Bao nhiêu tiền", audio:how_much, picture:how_much_pic},
    {id: 1, english: "Want", vietnamese: "Muốn", example:"Tôi muốn mua xoài", audio:want, picture:want_pic},
    {id: 2, english: "Buy", vietnamese: "Mua", example:"Tôi muốn mua xoài", audio:buy, picture:buy_pic},
    {id: 3, english: "Cold tea", vietnamese: "Trà đá", example:"Cốc trà đá", audio:cold_tea, picture:cold_tea_pic},
    {id: 4, english: "Kilogram", vietnamese: "Cân", example:"Một ký xoài", audio:kilogram, picture:kilogram_pic},
    {id: 5, english: "Wait", vietnamese: "Chờ", example:"Chờ tôi", audio:wait, picture:wait_pic},
    {id: 6, english: "VN currency", vietnamese: "Đồng", example:"100000 Đồng", audio:currency, picture:currency_pic},
    {id: 7, english: "Cost/price", vietnamese: "Trị giá", example:"Giá kem 15.000 đồng", audio:price, picture:price_pic},
    {id: 8, english: "Sell", vietnamese: "Bán", example:"50% Bán", audio:sell, picture:sell_pic},
    {id: 9, english: "Money", vietnamese: "Tiền", example:"Tiền của tôi", audio:money, picture:money_pic},
    {id: 10, english: "Welcome", vietnamese: "Mời vào", example:"Mời vào", audio:welcome, picture:welcome_pic},
    {id: 11, english: "Eat", vietnamese: "Ăn", example:"Ăn cơm", audio:eat, picture:eat_pic},
    {id: 12, english: "Please", vietnamese: "Làm ơn", example:"Làm ơn đợi tôi", audio:please, picture:please_pic},
    {id: 13, english: "Rice noodle", vietnamese: "Bún chả", example:"Bún chả", audio:rice_noodle, picture:rice_noodle_pic},
    {id: 14, english: "Unit", vietnamese: "Suất", example:"Suất 1", audio:unit, picture:unit_pic},
    {id: 15, english: "Cup", vietnamese: "Cốc", example:"Một cốc cà phê", audio:cup, picture:cup_pic},
]